"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Return the current list item, from current selection or from a node.
 */
var getCurrentItem = function (opts) { return function (value, block) {
    var document = value.document;
    if (!block) {
        if (!value.selection.start.key) {
            return null;
        }
        block = value.startBlock;
    }
    var parent = document.getParent(block.key);
    return parent && parent.type === opts.typeItem ? parent : null;
}; };
exports.default = getCurrentItem;
//# sourceMappingURL=getCurrentItem.js.map